(function () {
  function initializeBlogCta() {
    var root = document.querySelector('[data-raelon-blog-cta-root]');
    if (!root || root.dataset.initialized === 'true') return;

    root.dataset.initialized = 'true';

    var drawer = root.querySelector('[data-raelon-blog-drawer]');
    var panel = root.querySelector('.raelon-blog-drawer__panel');
    var contextInput = root.querySelector('[data-raelon-blog-cta-context]');
    var titleElement = root.querySelector('#raelon-blog-drawer-title');
    var equipmentInput = root.querySelector('[data-raelon-blog-cta-equipment-interest]');
    var closeButtons = root.querySelectorAll('[data-raelon-blog-drawer-close]');
    var configSource = document.querySelector('.raelon-blog-contextual-cta') || document.querySelector('.raelon-blog-cta-trigger');
    var sticky = root.querySelector('[data-raelon-blog-cta-trigger]');
    var form = root.querySelector('#raelon-blog-contact-form');
    var lastTrigger = null;

    if (!drawer || !panel || !contextInput || !configSource) return;

    root.dataset.stickyLabel = configSource.dataset.stickyLabel || 'Need Help Choosing?';
    root.dataset.drawerTitle = configSource.dataset.drawerTitle || 'Get an Equipment Recommendation';
    root.dataset.equipmentInterest = configSource.dataset.equipmentInterest || '';
    if (sticky) sticky.textContent = root.dataset.stickyLabel;
    if (titleElement) titleElement.textContent = root.dataset.drawerTitle;
    if (equipmentInput) equipmentInput.value = root.dataset.equipmentInterest;

    function getTriggers() {
      return document.querySelectorAll('[data-raelon-blog-cta-trigger], .raelon-blog-cta-trigger');
    }

    function getConfig(trigger, key, fallback) {
      return (trigger && trigger.dataset[key]) || root.dataset[key] || fallback;
    }

    function openDrawer(trigger) {
      lastTrigger = trigger || null;
      contextInput.value = trigger && trigger.dataset.ctaContext
        ? trigger.dataset.ctaContext
        : trigger && trigger.classList.contains('raelon-blog-cta-trigger')
          ? 'Mid-Article CTA'
          : 'Sticky CTA';
      if (titleElement) titleElement.textContent = getConfig(trigger, 'drawerTitle', 'Get an Equipment Recommendation');
      if (equipmentInput) equipmentInput.value = getConfig(trigger, 'equipmentInterest', '');
      if (sticky) sticky.textContent = getConfig(trigger, 'stickyLabel', 'Need Help Choosing?');
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('raelon-blog-drawer-open');
      getTriggers().forEach(function (item) {
        item.setAttribute('aria-expanded', 'true');
      });
      window.requestAnimationFrame(function () {
        panel.focus();
      });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('raelon-blog-drawer-open');
      getTriggers().forEach(function (item) {
        item.setAttribute('aria-expanded', 'false');
      });
      if (lastTrigger) lastTrigger.focus();
    }

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest
        ? event.target.closest('[data-raelon-blog-cta-trigger], .raelon-blog-cta-trigger')
        : null;
      if (trigger) openDrawer(trigger);
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    if (form) {
      var submitButton = form.querySelector('[type="submit"]');
      var submitLabel = submitButton ? submitButton.textContent : '';
      var isSubmitting = false;
      var isSending = false;

      function getNotice() {
        var notice = form.querySelector('.raelon-blog-drawer__notice');
        if (notice) return notice;

        notice = document.createElement('div');
        notice.className = 'raelon-blog-drawer__notice';
        notice.hidden = true;
        form.insertBefore(notice, form.firstChild);
        return notice;
      }

      function showNotice(type, content) {
        var notice = getNotice();
        notice.className = 'raelon-blog-drawer__notice raelon-blog-drawer__notice--' + type;
        notice.setAttribute('role', type === 'error' ? 'alert' : 'status');
        notice.innerHTML = content;
        notice.hidden = false;
      }

      function preserveAttributionAndReset() {
        var hiddenFields = Array.prototype.map.call(
          form.querySelectorAll('input[type="hidden"][name^="contact["]'),
          function (field) {
            return { name: field.name, value: field.value };
          }
        );

        form.reset();
        form.querySelectorAll(
          '[name="form_key"], [name="h-captcha-response"], [name="g-recaptcha-response"], [name="recaptcha-v3-token"]'
        ).forEach(function (field) {
          field.remove();
        });
        hiddenFields.forEach(function (savedField) {
          var field = Array.prototype.find.call(form.elements, function (element) {
            return element.name === savedField.name;
          });
          if (field) field.value = savedField.value;
        });
      }

      function setSubmittingState() {
        var notice = getNotice();
        notice.hidden = true;
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = root.dataset.sendingText || 'Sending...';
        }
      }

      function submitAsync() {
        if (isSending) return;
        if (!isSubmitting) {
          isSubmitting = true;
          setSubmittingState();
        }
        isSending = true;

        fetch(form.action, {
          method: form.method || 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' }
        })
          .then(function (response) {
            return response.text().then(function (html) {
              return { response: response, html: html };
            });
          })
          .then(function (result) {
            var responseDocument = new DOMParser().parseFromString(result.html, 'text/html');
            var responseUrl = new URL(result.response.url, window.location.origin);
            var responseError = responseDocument.querySelector(
              '#raelon-blog-contact-form .raelon-blog-drawer__notice--error, ' +
              '.raelon-blog-drawer__notice--error, ' +
              '.raelon-header-quick-quote__notice--error'
            );
            var accepted = responseUrl.searchParams.get('contact_posted') === 'true' ||
              Boolean(responseDocument.querySelector(
                '.raelon-blog-drawer__notice--success, .raelon-header-quick-quote__notice--success'
              ));

            if (accepted) {
              preserveAttributionAndReset();
              showNotice(
                'success',
                root.dataset.successHtml || '<strong>Request Sent Successfully</strong><br>Thanks! We received your request and our team will get back to you soon.'
              );
              return;
            }

            if (responseError) {
              showNotice('error', responseError.innerHTML);
              return;
            }

            throw new Error('Shopify did not confirm the contact request.');
          })
          .catch(function () {
            showNotice('error', root.dataset.errorText || 'We could not send your request. Please review your information and try again.');
          })
          .finally(function () {
            isSending = false;
            isSubmitting = false;
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.textContent = submitLabel;
            }
          });
      }

      form.submit = submitAsync;
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (isSubmitting) return;

        isSubmitting = true;
        setSubmittingState();

        if (form.dataset.hcaptchaBound !== 'true') {
          window.setTimeout(function () {
            if (
              isSubmitting &&
              !isSending &&
              form.dataset.hcaptchaBound === 'true' &&
              typeof form.requestSubmit === 'function'
            ) {
              form.requestSubmit();
            }
          }, 1000);
        }
      });
    }

    if (root.querySelector('.raelon-blog-drawer__notice')) openDrawer(null);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeBlogCta);
  } else {
    initializeBlogCta();
  }
})();
